import type { AdditionalContent } from 'bundles/browse-common/components/ValuePropositionComponent';

import _t from 'i18n!nls/browse-common';

export const getJustifyContent = (isSmallScreen: boolean, hasIcons: boolean) => {
  if (isSmallScreen) return 'flex-start';
  return hasIcons ? 'center' : 'flex-end';
};

export const getDisplayText = (content: AdditionalContent) => {
  if (content.text) return content.text;
  if (content.value !== undefined && content.value !== null && content.category) {
    return _t('{value} {category}', {
      value: content.value.toString(),
      category: content.category,
    });
  }
  return '';
};

export const getNumberAndLabel = (content: AdditionalContent) => {
  if (content.value !== undefined && content.value !== null && content.category) {
    return { number: content.value.toString(), label: content.category };
  }
  if (content.text) {
    const parts = content.text.split(' ');
    return { number: parts[0], label: parts.slice(1).join(' ') };
  }
  return { number: '', label: '' };
};
